import cx from 'classnames';
import { heartsUrl } from 'mk2/apps/hearts/urls';
import { mailBoxUrl } from 'mk2/apps/mail/urls';
import { wallMentionsUrl } from 'mk2/apps/wall/urls';
import AvatarImg from 'mk2/components/AvatarImg';
import styles from 'mk2/components/NotificationMenu.mscss';
import NotificationsBadge, { Type } from 'mk2/components/NotificationsBadge';
import { CompatibleLink } from 'mk2/containers/SiteMenu/SiteMenu';
import Loadable from 'mk2/helpers/Loadable';
import { url } from 'mk2/helpers/urls';
import { UserEntity } from 'mk2/schemas';
import colors from 'mk2/styles/colors.scss';
import React from 'react';

/* UserMenu is displayed on user interaction - so we can code split it safely */
const UserMenu = Loadable({
    loader: () => import('mk2/components/UserMenu' /* webpackChunkName: "components.UserMenu" */),
    modules: ['mk2/components/UserMenu'],
    webpack: () => [ require.resolveWeak('mk2/components/UserMenu') ],
});

interface OwnProps {
    mobile?: boolean;
    heartsCount: number;
    unreadMails: number;
    wallStatusNews: number;
    fluxibleCompatibility: boolean;
    requestUser: UserEntity;
    activeSection: string;
    activeItem: string;

    onItemClick();
    relocateWithNextParam(href: string);
}

type Props = OwnProps;

interface State {
    userbarOpened: boolean;
}

class NotificationMenu extends React.PureComponent<Props, State> {

    public static defaultProps: Partial<OwnProps> = {
        mobile: false,
    };

    public state: State = {
        userbarOpened: false,
    };

    public render() {
        const {
            mobile, heartsCount, unreadMails, fluxibleCompatibility, requestUser, wallStatusNews,
            activeItem, activeSection,
            onItemClick, relocateWithNextParam,
        } = this.props;

        return (
            <div className={cx(styles.NotificationMenu)}>
                <CompatibleLink
                    onClick={onItemClick}
                    fluxibleCompatibility={fluxibleCompatibility}
                    to={!fluxibleCompatibility ? heartsUrl : relocateWithNextParam(heartsUrl)}
                    className={cx(styles.NotificationMenu__userIcon, 'topmenu-userIcon', mobile && styles['NotificationMenu__userIcon--mobile'], (activeSection === 'hearts') ? cx(styles['NotificationMenu__userIcon--active'], 'topmenu-activeLink') : null)}
                >
                    <i className={cx(styles.NotificationMenu__userIcon__icon, 'fa', 'fa-heart-o')} />
                    {(heartsCount > 0) ? (
                        <NotificationsBadge className={styles.NotificationMenu__badge} count={heartsCount} backgroundColor={mobile ? colors.menuHeader : colors.white} color={colors.primaryIcon} limit={false} />
                    ) : null}
                </CompatibleLink>
                <CompatibleLink
                    fluxibleCompatibility={fluxibleCompatibility}
                    onClick={onItemClick}
                    to={url(mailBoxUrl, {username: requestUser.username, folder: 'inbox'})}
                    className={cx(styles.NotificationMenu__userIcon, 'topmenu-userIcon', mobile && styles['NotificationMenu__userIcon--mobile'], (activeSection === 'mail') ? cx(styles['NotificationMenu__userIcon--active'], 'topmenu-activeLink') : null)}
                >
                    <i className={cx(styles.NotificationMenu__userIcon__icon, 'fa', 'fa-envelope-o')}/>
                    {(unreadMails > 0) ? (
                        <NotificationsBadge className={styles.NotificationMenu__badge} count={unreadMails} type={Type.Important} shadow limit={false} />
                    ) : null}
                </CompatibleLink>
                <CompatibleLink
                    fluxibleCompatibility={fluxibleCompatibility}
                    onClick={onItemClick}
                    to={url(wallMentionsUrl, {username: requestUser.username})}
                    className={cx(styles.NotificationMenu__userIcon, 'topmenu-userIcon', mobile && styles['NotificationMenu__userIcon--mobile'], (activeSection === 'wall') ? cx(styles['NotificationMenu__userIcon--active'], 'topmenu-activeLink') : null)}
                >
                    <i className={cx(styles.NotificationMenu__userIcon__icon, 'fa', 'fa-bell-o')}/>
                    {(wallStatusNews > 0) ? (
                        <NotificationsBadge className={styles.NotificationMenu__badge} count={wallStatusNews} type={Type.Important} shadow limit={false} />
                    ) : null}
                </CompatibleLink>

                <div className={cx(styles.NotificationMenu__userMenu, mobile && styles['NotificationMenu__userMenu--mobile'])}>
                    <button type="button" className={styles['NotificationMenu__userMenu--avatarCtt']} onClick={this.onUserMenuClick}>
                        <AvatarImg className={styles['NotificationMenu__userMenu--avatar']} size={28} user={requestUser}/>
                    </button>
                    {this.state.userbarOpened && (
                        <UserMenu
                            requestUser={requestUser}
                            fluxibleCompatibility={fluxibleCompatibility}
                            activeItem={activeItem}
                            activeSection={activeSection}
                            onItemClick={onItemClick}
                        />
                    )}
                </div>
            </div>
        );
    }

    public close() {
        this.setState({
            userbarOpened: false,
        });
    }

    private onUserMenuClick = () => {
        this.setState({
            userbarOpened: !this.state.userbarOpened,
        });
    };

}

export default NotificationMenu;
